import Group from 'components/utils/Group'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import PriceRowAgentHubCommission from 'agentHub/components/PriceRowAgentHubCommission'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import { getAgentHubExperienceType } from 'lib/agentHub/agentHubUtils'
import ExperienceTilePrices from 'components/Experiences/ExperienceTiles/ExperienceTilePrices'
import { ViewOfferButton } from './ViewOfferButton'
import LoyaltyBurnPriceDisplay from 'loyalty/components/LoyaltyBurnPriceDisplay'
import useSearchOfferBurnPricing from 'hooks/useSearchOfferBurnPricing'
import { getExperienceTileSaleUnit } from 'lib/experiences/getExperienceTileSaleUnit'

interface Props {
  experience: App.ExperienceBookingView
  variant?: 'default' | 'condensed'
  viewPriceInPoints?: boolean
}

function ExperienceOfferPriceDetails(props: Props) {
  const { experience, variant = 'default', viewPriceInPoints: viewPriceInPointsProp = false } = props
  const intl = useIntl()
  const productType = useMemo(() => getAgentHubExperienceType(experience.originalExperience), [experience])
  const { pricing, location } = experience
  const { priceInPoints, memberPriceInPoints, pointsToBurn, pointsOnly, hideZeroCash, shouldShowBurn } = useSearchOfferBurnPricing({
    price: pricing.price,
    memberPrice: pricing.memberPrice,
    loyaltyProductType: 'experience',
    viewPriceInPoints: viewPriceInPointsProp,
  })
  const saleUnit = getExperienceTileSaleUnit({
    isFromPrice: true,
    ticketUnitLabel: pricing.saleUnit,
    totalLabel: intl.formatMessage({
      id: 'whMf0sOzbI-AWwhc2zR7',
      defaultMessage: 'total',
      description: 'Sale unit label for total price on experience tile prices',
    }),
  })
  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="end">
      <Group direction="vertical" verticalAlign="end">
        {shouldShowBurn && <>
          <PriceRowPriceCaption>{intl.formatMessage({
            id: 'EAQ_GV7KRwveLWB08EmL',
            defaultMessage: 'From',
            description: 'Price caption prefix on the experience tile prices',
          })}
          </PriceRowPriceCaption>
          <LoyaltyBurnPriceDisplay
            totalPrice={pricing.price}
            pointsToBurn={pointsToBurn}
            priceInPoints={priceInPoints}
            memberPrice={pricing.memberPrice}
            memberPriceInPoints={memberPriceInPoints}
            size="L"
            saleUnit={saleUnit}
            pointsOnly={pointsOnly}
            hideZeroCash={hideZeroCash}
          />
        </>}
        {!shouldShowBurn && <ExperienceTilePrices
          isFromPrice
          totalPrice={pricing.price}
          totalMemberPrice={pricing.memberPrice}
          totalGrossPrice={pricing.value}
          discountPercentage={pricing.discountPercent}
          ticketUnitLabel={pricing.saleUnit}
          size="L"
          nonMemberPriceSize="L"
        />}
        <PriceRowAgentHubCommission
          offer={experience.originalExperience}
          offerId={experience.id}
          productType={productType}
          offerLocations={location ? [location] : undefined}
        />
      </Group>
      <ViewOfferButton variant={variant} />
    </Group>
  )
}

export default ExperienceOfferPriceDetails
